<template>
	<div class="option-header domain-entry">
		<span>{{ domain.name }}</span>
		<a class="panel_item_btn delete_btn" v-if="domain.id > 1" @click="deleteDomain(domain.id)">
			<v-spinner v-if="deleting" />
			<inline-svg v-else :src="require('@/assets/img/delete_icon.svg')"/>
		</a>
		<span v-else class="tag">[your default domain]</span>
	</div>
</template>

<script>

import API from "@/api"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import VSpinner from "@/components/base/v-spinner";
import ConnectNewDomainPopup from "@/components/popups/domains/connect-new-domain-popup";

export default {
	name: "DomainEntry",
	mixins: [API],
	components: {
		ConnectNewDomainPopup,
		VSpinner,
		Popup,
		VButton
	},
	props: ['domain'],
	data() {
		return {
			deleting: false,
		}
	},
	methods: {
		async deleteDomain() {
			try {
				if (!confirm("Are you sure, you want to disconnect this domain name?")) return;
				this.deleting = true;
				let res = await this.api.wsteps.deleteDomain(this.domain.id);
				console.log("res:", res);
				this.$emit('delete', this.domain.id)
			} catch (e) {
				this.$notify({
					type:"warn",
					group: "main",
					title: "Something went wrong... Please try again later",
				});
				console.error("error", e);
			} finally {
				this.deleting = false;
			}
		}
	},
	computed: {}
}
</script>
<style lang="scss" scoped>
.domains-popup {
	.option-header {
		cursor: inherit;
		height: 40px;
		padding: 4px 15px;
		align-items: center;
		> span {
			display: flex;
			flex: 1;
		}
		//.delete_btn {
		//	display: none;
		//}
		//&:hover {
		//	.delete_btn {
		//		display: flex;
		//	}
		//}
	}
	.tag {
		position: relative;
		padding: 5px;
		flex: 0 !important;
		white-space: nowrap;
		color: silver;
		font-style: italic;
	}
	.delete_btn {
		position: relative;
		padding: 5px;
		min-width: 30px;
		min-height: 30px;
		width: 36px;
		height: 34px;
	}
}
</style>
